// TODO: solve the eslint issue.
import config from '@/config';
// import { HOST_PORTAL_URL } from 'services/connections.service';

export const BOTPRESS_WEBCHAT_SCRIPT_URL =
  'https://cdn.botpress.cloud/webchat/v2.2/inject.js';

// TODO: Hardik/Hardik - in final version we will have only one set of credentials even for non production environments - perform cleanup after 22 March 2025
let botId;
let clientId;
if (config.isProduction) {
  botId = '08662afb-70dd-4586-a7e1-608da3179f2b';
  clientId = 'd84e43cf-62f8-4d1e-ad1b-c9f1c271e6de';
} else {
  botId = '9dec35cc-666a-4855-bf78-2d37fbe88143';
  clientId = '8d03f638-199b-4958-a726-3a9a41e01713';
}
const BOT_ID = botId;
const CLIENT_ID = clientId;

const APPEARANCE_CONFIGURATION = {
  // additionalStylesheetUrl: `${HOST_PORTAL_URL}/styles/botpress-webchat-heba.css`,
  // additionalStylesheetUrl: `https://uat.hafla.com/styles/botpress-webchat-heba.css`, // for local point to a static file that is publically available outside of the host-portal-ui server so that botpress script if getting executed on botpress server can access this css -- tried not working
  // additionalStylesheetUrl: 'https://files.bpcontent.cloud/2025/02/24/17/20250224172325-UJ1VFD34.css',
  allowFileUpload: true,
  botAvatar:
    'https://files.bpcontent.cloud/2025/02/04/10/20250204102941-RTO576B3.png',
  botDescription:
    'Welcome to Hafla, where events are made easy! 🎉 I’m Heba, your AI event planning teammate.',
  botName: 'Hafla Event Brief AI',
  color: '#FD409A',
  composerPlaceholder: 'Help me plan my dream event',
  email: { link: 'contactus@hafla.com', title: 'contactus@hafla.com' },
  fontFamily: 'ibm',
  phone: { link: '+97145616897', title: '+97145616897' },
  privacyPolicy: {
    link: 'https://www.hafla.com/privacy-policy',
    title: 'https://www.hafla.com/privacy-policy'
  },
  radius: 2,
  showPoweredBy: false,
  termsOfService: {
    link: 'https://www.hafla.com/terms-and-conditions',
    title: 'https://www.hafla.com/terms-and-conditions'
  },
  themeMode: 'light',
  variant: 'soft',
  website: { link: 'https://www.hafla.com', title: 'https://www.hafla.com' }
};

export const WEBCHAT_HEBA_CONFIGURATION = {
  botId: BOT_ID,
  clientId: CLIENT_ID,
  configuration: APPEARANCE_CONFIGURATION
  // style: `${HOST_PORTAL_URL}/styles/botpress-webchat-heba.css`
  // theme: theme
};

export const WEBCHAT_HEBA_CONFIGURATION_STRING = JSON.stringify(
  WEBCHAT_HEBA_CONFIGURATION
);
